import userApi from '@/api/sy/user'
let Base64 = require('js-base64').Base64;

const user = {
    state: {
        id: null,
        name: '',
        changePwd: false, //true: 强制修改密码
        teacherId: 0,
        // unitName: '',
        dataRange: 0,
        workinfo: {
            ToDoCount: 0,
            ToReadCount: 0,
            ToEndCount: 0
        }
    },
    getters: {
        hasIdentityInfo: state => {
            return state.id != null
        },
        isLogin: state => {
            // return sessionStorage.getItem("token") ? true : false
            return localStorage.getItem("token") ? true : false
        }
    },
    mutations: {
        SET_ID(state, id) {
            state.id = id
        },
        SET_NAME(state, name) {
            state.name = name
        },
        SET_CHANGEPWD(state, changePwd) {
            state.changePwd = changePwd
        },
        SET_TEACHERID(state, teacherId) {
            state.teacherId = teacherId
        },
        // SET_UNITNAME(state, unitName) {
        //   state.unitName = unitName;
        // },
        SET_DATA_RANGE(state, dataRange) {
            state.dataRange = dataRange
        },
        SET_WORK_INFO(state, workinfo) {
            state.workinfo.ToDoCount = workinfo.ToDoCount;
            state.workinfo.ToReadCount = workinfo.ToReadCount;
            state.workinfo.ToEndCount = workinfo.ToEndCount;
        }
    },
    actions: {
        setChangePwd({ commit }, changePwd) {
            commit('SET_CHANGEPWD', changePwd)
        },
        login({ commit }, user) {
            return new Promise((resolve, reject) => {
                let info = {};
                // info.LoginId = Base64.encode(user.LoginId);
                // info.Pwd = Base64.encode(user.Pwd);
                // info.Code = Base64.encode(user.Code);
                userApi.login(user).then(res => {
                    if (res.Code == 0) {
                        localStorage.setItem("token", res.Data.Token);
                        localStorage.setItem("refresh", res.Data.RefreshToken);

                        let loginInfo = {
                            UserId: res.Data.Id,
                            UserName: res.Data.Name,
                            TermId: res.Data.TermId,
                            TeacherId: res.Data.TeacherId,
                            ChangePwd: res.Data.ChangePwd,
                            JobNames: res.Data.JobNames,
                            ClassId: res.Data.ClassId,
                            GradeId: res.Data.GradeId,
                            TeachGradeIds: res.Data.TeachGradeIds,
                            HasDormitory: res.Data.HasDormitory
                        }
                        localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
                        resolve(res);
                    } else {
                        reject(res);
                    }
                })
            })
        },
        loginByMobile({ commit, dispatch }, user) {
            return new Promise((resolve, reject) => {
                userApi.loginByMobile(user).then(res => {
                    if (res.Code == 0) {
                        // sessionStorage.setItem("token", res.Data.Token);
                        localStorage.setItem("token", res.Data.Token);
                        localStorage.setItem("refresh", res.Data.RefreshToken);
                        let loginInfo = {
                            UserId: res.Data.Id,
                            UserName: res.Data.Name,
                            ChangePwd: res.Data.ChangePwd,
                            TeachGradeIds: res.Data.TeachGradeIds
                            // UnitName: res.Data.UnitName
                        }
                        localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
                        // dispatch("getIdentityInfo");
                        resolve(res);
                    } else {
                        reject(res);
                    }
                })
            })
        },
        loginByCode({ commit, dispatch }, code) {
            return new Promise((resolve, reject) => {
                userApi.loginByCode(code).then(res => {
                    if (res.Code == 0) {
                        // sessionStorage.setItem("token", res.Data.Token);
                        localStorage.setItem("token", res.Data.Token);
                        localStorage.setItem("refresh", res.Data.RefreshToken);
                        let loginInfo = {
                            UserId: res.Data.Id,
                            UserName: res.Data.Name,
                            TermId: res.Data.TermId,
                            TeacherId: res.Data.TeacherId,
                            ChangePwd: false, // res.Data.ChangePwd,
                            JobNames: res.Data.JobNames,
                            TeachGradeIds: res.Data.TeachGradeIds

                        }
                        localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
                        // dispatch("getIdentityInfo");
                        resolve(res);
                    } else {
                        reject(res);
                    }
                })
            })
        },
        getIdentityInfo({ commit, dispatch }) {
            return new Promise((resolve, reject) => {

                var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
                commit('SET_ID', loginInfo.UserId)
                commit('SET_NAME', loginInfo.UserName)
                commit('SET_CHANGEPWD', loginInfo.ChangePwd)
                commit('SET_TEACHERID', loginInfo.TeacherId)
                // commit('SET_UNITNAME', loginInfo.UnitName)

                userApi.getPermission().then(res => {
                    if (res.Data != null) {
                        let dataRange = res.Data.Roles.some(item => item.DataRange == 1)
                        commit('SET_DATA_RANGE', dataRange)

                        // var menu = res.Data.Menus.find(x=>x.MenuId==11)
                        // menu.Pid = 5;
               

                        function buildPermissionAndFullPath(menu) {
                            res.Data.Menus.forEach((m, i) => {
                                if (m.Pid == menu.MenuId) {
                                    // if (m.MenuName == "学生信息管理") {
                                    //     m.FullPath = "/st/" + m.Url;
                                    //     m.PermissionPath = "st." + m.Url;
                                    // } else {
                                    //  m.FullPath = menu.FullPath + '/' + m.Url;
                                    //  m.PermissionPath = (menu.PermissionPath ? (menu.PermissionPath + '.') : "") + m.Url;
                                    // }
                                     if (m.Url[0]=='/') {
                                        m.FullPath = m.Url;
                                        m.PermissionPath = m.Url.substring(1).replace("/",".");
                                     } else {
                                        m.FullPath = menu.FullPath + '/' + m.Url;
                                        m.PermissionPath = (menu.PermissionPath ? (menu.PermissionPath + '.') : "") + m.Url;
                                    }
                                    buildPermissionAndFullPath(m);
                                }
                            })
                        }
                        buildPermissionAndFullPath({
                            MenuId: 0,
                            FullPath: "",
                            PermissionPath: ""
                        });
                        commit("SET_PERMISSION_MENUS", res.Data.Menus, { root: true });
                        resolve(res.Data)
                    }
                }).catch(error => {
                    dispatch('logout')
                    reject(error)
                })
            })
        },
        logout({ commit }) {
            return new Promise((resolve, reject) => {
                userApi.logout().then(res => {
                    commit('SET_ID', null)
                    resolve(res.Data)
                })
            })
        },
        getWorkbench({ commit }) {
            return new Promise((resolve, reject) => {
                userApi.getWorkbench().then(res => {
                    commit('SET_WORK_INFO', res.Data)
                    resolve(res.Data)
                })
            })
        },
        refreshToken({ commit }) {
            return new Promise((resolve, reject) => {
                let data = {
                    Token: localStorage.getItem("token"),
                    RefreshToken: localStorage.getItem("refresh")
                }
                // console.log('rdata', data)
                userApi.refreshToken(data).then(res => {
                    // console.log('refreshToken', res)
                    if (res.Code == 0 && res.Data != null) {
                        localStorage.setItem("token", res.Data.Token);
                        localStorage.setItem("refresh", res.Data.RefreshToken);
                        // sessionStorage.setItem("token", res.Data.Token);
                        // sessionStorage.setItem("refresh", res.Data.RefreshToken);
                    }
                    resolve(res)
                })
            })
        },
        clearStorage({ commit }) {
            localStorage.removeItem("token");
            localStorage.removeItem("refresh");

            // sessionStorage.removeItem("token")
            // sessionStorage.removeItem("refresh")
            localStorage.removeItem("loginInfo")
            // window.location.href = window.location.origin + '/#/register';
            // window.location.reload();
        },
    }
}
export default user